'use client';

import React from 'react';
import { SpinnerGapIcon } from '@phosphor-icons/react';
import { Icon, Stack, Text } from '@tranquility-ai/theme-components/primitives';

import {
  OBFUSCATION_FAILED_MESSAGE,
  OBFUSCATION_PENDING_MESSAGE,
  OBFUSCATION_SLOW_MESSAGE,
} from './media-flag-rules';

import './media-obfuscation-pending.css';

/** ``slow`` still spins — the blur worker has not given up, it is just late. */
export type MediaObfuscationState = 'pending' | 'slow' | 'failed';

/**
 * Full-frame replacement while a user-flagged image is being obfuscated (TR-3168).
 * Candidate for promotion once the production poll path ships.
 */
export function MediaObfuscationPending({
  state = 'pending',
}: {
  state?: MediaObfuscationState;
}) {
  if (state === 'failed') {
    return (
      <Stack
        gap="sm"
        align="center"
        justify="center"
        className="tp-media-obfuscation-pending"
        role="alert"
      >
        <Text variant="bodySmall">{OBFUSCATION_FAILED_MESSAGE}</Text>
      </Stack>
    );
  }

  return (
    <Stack
      gap="sm"
      align="center"
      justify="center"
      className="tp-media-obfuscation-pending"
      role="status"
      aria-live="polite"
    >
      <Icon icon={SpinnerGapIcon} size="lg" className="tp-media-obfuscation-pending__spinner" />
      <Text variant="bodySmall">
        {state === 'slow' ? OBFUSCATION_SLOW_MESSAGE : OBFUSCATION_PENDING_MESSAGE}
      </Text>
    </Stack>
  );
}
